import { ModalProps } from './types';

export const styles = {
  overlay: 'tw-fixed tw-inset-0 tw-z-50 tw-bg-black tw-bg-opacity-50 tw-backdrop-blur-sm tw-flex tw-items-center tw-justify-center tw-p-4',
  container: 'tw-bg-white tw-rounded-md tw-shadow-xl tw-flex tw-flex-col tw-max-h-[90vh] tw-overflow-hidden',
  header: 'tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 tw-border-b tw-border-neutral-200',
  title: 'tw-text-lg tw-font-semibold tw-text-neutral-900 tw-m-0',
  closeButton: 'tw-w-5 tw-h-5',
  body: 'tw-flex-1 tw-overflow-y-auto tw-px-6 tw-py-4',
  footer: 'tw-flex tw-items-center tw-justify-end tw-gap-3 tw-px-6 tw-py-4 tw-border-t tw-border-neutral-200 tw-bg-neutral-50',
};

export const sizeStyles: Record<NonNullable<ModalProps['size']>, string> = {
  sm: 'tw-w-full tw-max-w-sm',
  md: 'tw-w-full tw-max-w-md',
  lg: 'tw-w-full tw-max-w-lg',
  xl: 'tw-w-full tw-max-w-xl',
};
